import React from 'react'
import { useIntl } from 'react-intl'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import { Box, TableHead } from '@mui/material'
import EditIcon from '../../../../../../assets/icons/Edit/Edit.svg'
import ConfirmDelete from '../../../../../../components/dialogs/ConfirmDelete'
import { CoursePackageState } from '../../../../../../features/types'

interface Props {
    packages: CoursePackageState[]
    isFetching: boolean
    onEdit: (row: CoursePackageState) => void
    onDelete: (id: number) => void
}

const styles = {
    tableContainer: {
        border: 1,
        borderColor: 'grey.100',
        borderRadius: 2,
    },
    table: {
        minWidth: 500,
    },
    tableHead: {
        bgcolor: 'grey.100',
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'end',
    },
    iconButton: {
        background: '#f3f4f5',
        mr: 2,
    },
}

const BundleTable: React.FC<Props> = ({
    packages = [],
    isFetching = false,
    onEdit,
    onDelete,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={styles.tableContainer}
                elevation={0}
            >
                <Table
                    sx={styles.table}
                    aria-label="custom pagination table"
                >
                    <TableHead sx={styles.tableHead}>
                        <TableRow>
                            <TableCell>#</TableCell>

                            <TableCell>
                                {formatMessage({ id: 'sloganKz' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'sloganRu' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'noOfSubjects' })}
                            </TableCell>

                            <TableCell>
                                {formatMessage({ id: 'discount%' })}
                            </TableCell>

                            <TableCell
                                align="right"
                                width={12}
                            >
                                {formatMessage({ id: 'actions' })}
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {packages.length
                            ? packages.map((row, index) => (
                                  <TableRow key={row.id}>
                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {index + 1}.
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {row.sloganKz.substring(0, 15)}
                                          {row.sloganKz.length > 15 && '...'}
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {row.sloganRu.substring(0, 15)}
                                          {row.sloganRu.length > 15 && '...'}
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {row.subjectCount}
                                      </TableCell>

                                      <TableCell
                                          component="th"
                                          scope="row"
                                      >
                                          {row.discount}%
                                      </TableCell>

                                      <TableCell
                                          style={styles.flexEnd}
                                          align="right"
                                      >
                                          <ConfirmDelete
                                              confirmAction={() =>
                                                  onDelete(row.id)
                                              }
                                          />

                                          <IconButton
                                              sx={styles.iconButton}
                                              onClick={() => onEdit(row)}
                                          >
                                              <img
                                                  src={EditIcon}
                                                  alt="edit"
                                              />
                                          </IconButton>
                                      </TableCell>
                                  </TableRow>
                              ))
                            : !isFetching && (
                                  <TableRow>
                                      <TableCell
                                          component="th"
                                          scope="row"
                                          align="center"
                                          colSpan={10}
                                      >
                                          {formatMessage({ id: 'noData' })}
                                      </TableCell>
                                  </TableRow>
                              )}

                    </TableBody>

                </Table>
            </TableContainer>
        </Box>
    )
}

export default BundleTable
